<div class="vendor-multi-pick">
	<div class="vendor-multi-pick-toolbar" *ngIf="showIncludeInactiveToggle">
		<mat-slide-toggle [(ngModel)]="includeInactive" (change)="onIncludeInactiveChange()">Include inactive</mat-slide-toggle>
	</div>
	<div class="vendor-multi-pick-toolbar">
		<button type="button" class="btn btn-sm btn-outline-secondary" (click)="selectAllVisible()" [disabled]="loading || !vendorPickList.length">Select all</button>
		<button type="button" class="btn btn-sm btn-outline-secondary" (click)="selectNoneVisible()" [disabled]="loading || !vendorPickList.length">Select none</button>
		<span class="text-muted small ms-2" *ngIf="loading">Loading vendors…</span>
		<span class="text-muted small ms-2" *ngIf="!loading && !filteredRows.length">No vendors match the current filter.</span>
	</div>
	<div class="vendor-multi-pick-scroll" *ngIf="filteredRows.length">
		<div *ngFor="let row of filteredRows; let i = index; trackBy: trackBySupplier" class="form-check vendor-multi-pick-row">
			<input
				class="form-check-input"
				type="checkbox"
				[id]="'vmp-' + i"
				[(ngModel)]="row.selected"
				(change)="onRowToggle()"
			/>
			<label class="form-check-label" [for]="'vmp-' + i">
				<b>{{ row.supplierid }}</b> — {{ row.suppname }}
			</label>
		</div>
	</div>
</div>
